<template>
  <main
    data-testid="auth-error-page"
    class="min-h-[calc(100vh-64px)] bg-slate-950 text-slate-100 flex items-center justify-center px-4 py-12"
  >
    <section class="w-full max-w-md text-center">
      <div
        class="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full border border-red-400/40 bg-red-500/10 text-red-200"
        aria-hidden="true"
      >
        !
      </div>
      <p class="text-sm font-semibold uppercase text-red-200">
        {{ t("authError.signInFailed") }}
      </p>
      <h1 class="mt-3 text-2xl font-semibold text-white">
        {{ t("authError.title") }}
      </h1>
      <p class="mt-4 text-sm leading-6 text-slate-300">
        {{ message }}
      </p>
      <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
        <button
          type="button"
          class="inline-flex min-h-11 items-center justify-center rounded-md bg-blue-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
          @click="$emit('retry-login')"
        >
          {{ t("authError.retryLogin") }}
        </button>
        <button
          type="button"
          class="inline-flex min-h-11 items-center justify-center rounded-md border border-slate-700 px-5 py-2.5 text-sm font-semibold text-slate-100 transition hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-500"
          @click="$emit('go-home')"
        >
          {{ t("authError.goHome") }}
        </button>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "../i18n";

export default defineComponent({
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  emits: ["retry-login", "go-home"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
